import { useEffect, useRef, useState } from "react";

import { createReviewCycleCopySelection } from "../../../../../api/services";

/**
 * Creates the copied cycle's subject selection server-side (the cycle's still-active subjects).
 * Runs once; the wizard takes over the selection from there.
 */
export const useCopySubjectSelection = (copyCycleId: string | null, enabled: boolean) => {
	const [selection, setSelection] = useState<{ userSelectionId: string; selectedCount: number } | null>(null);
	const [isError, setIsError] = useState(false);
	const startedRef = useRef(false);

	useEffect(() => {
		if (!enabled || startedRef.current || !copyCycleId) return;
		startedRef.current = true;
		createReviewCycleCopySelection(copyCycleId)
			.then(setSelection)
			.catch(() => setIsError(true));
	}, [enabled, copyCycleId]);

	return {
		userSelectionId: selection?.userSelectionId ?? null,
		selectedCount: selection?.selectedCount ?? 0,
		isLoading: enabled && !selection && !isError,
		isError: enabled && isError,
	};
};
